export function hasClass(el: any, classString: string) {
    return (el.getAttribute('class') && el.getAttribute('class').indexOf(classString) !== -1);
}